import { useAtomValue } from "jotai";
import type { FunctionComponent, ReactNode } from "react";

import { accountAtom } from "shared/lib/account";

import { IdleQueue } from "scmp-app/components/common/idle-queue";
import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import { HeaderFeaturesMyNews } from "scmp-app/components/header/features/my-news";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";

import { Container, StyledDynamicSubscriptionButton } from "./styles";

export type HeaderFeaturesSubscriptionProps = HeaderFeatureCommonProps & {
  fallback?: ReactNode;
  showWhenLoggedIn?: boolean;
};

export const HeaderFeaturesSubscription: FunctionComponent<HeaderFeaturesSubscriptionProps> = ({
  fallback = <HeaderFeaturesMyNews />,
  showWhenLoggedIn = false,
  ...props
}) => {
  const { isLoggedIn } = useAtomValue(accountAtom);

  if (showWhenLoggedIn && !isLoggedIn) {
    return null;
  }
  return (
    <IdleQueue>
      <Container {...getResponsiveProps(props)}>
        <StyledDynamicSubscriptionButton fallback={fallback} variant="dusty-blue" />
      </Container>
    </IdleQueue>
  );
};

HeaderFeaturesSubscription.displayName = "HeaderFeaturesSubscription";
